import { BaseElement } from '../../../base-element';
import type { EntryPricingQuoteDto, TrialEventRegistrationConfigDto } from '../../../../api/types';
import '../../../ui/dt-section-card';

export class FeesSection extends BaseElement {
  private _quote: EntryPricingQuoteDto | null = null;
  private _config: TrialEventRegistrationConfigDto | null = null;

  set quote(value: EntryPricingQuoteDto | null) { this._quote = value; this.updateRender(); }
  set config(value: TrialEventRegistrationConfigDto | null) { this._config = value; this.updateRender(); }
  connectedCallback(): void { this.updateRender(); }

  private money(value: number): string { return `${value.toFixed(2)} USD`; }

  private updateRender(): void {
    const quote = this._quote;
    this.render(`
      <dt-section-card heading="Entry Fees" icon="receipt" data-testid="fees-section">
        <div class="grid min-w-0 gap-3 text-sm" aria-live="polite">
          ${quote ? `
            <p data-testid="pricing-tier-badge">Server pricing tier: ${this.esc(quote.pricingTier)}</p>
            <div class="grid gap-2" data-testid="fee-breakdown">
              ${quote.items.map(item => {
                const trial = this._config?.actualTrials.find(trial => trial.actualTrialId === item.actualTrialId);
                return `<div class="break-words">${this.esc(trial ? `${trial.date} / Trial ${trial.trialNumberOnDate}` : item.actualTrialId)}
                  / ${this.esc(item.stock)} / ${this.esc(item.division)}${item.isFeo ? ' / FEO' : ''}:
                  ${this.money(item.unitRate)} per run = ${this.money(item.lineAmount)}</div>`;
              }).join('')}
              <p>Subtotal: ${this.money(quote.subtotal)}</p>
              ${quote.discounts.map(discount => `<p>${this.esc(discount.kind)}: -${this.money(discount.amount)}</p>`).join('')}
            </div>
            <p class="text-lg font-semibold" data-testid="server-total">Total: ${this.money(quote.total)}</p>
            <p class="break-words text-xs">Quoted ${this.esc(quote.quotedAtUtc)} for entry revision ${quote.entryRevision}.
              Submission revalidates current pricing.</p>
          ` : `${this._config ? `<p data-testid="pricing-tier-badge">Server pricing tier: ${this.esc(this._config.fees.pricingTier)}</p>` : ''}
            <p>Save your runs to obtain current server pricing. No client estimate or editable total is used.</p>`}
          <p class="text-xs">Payment details are not collected here.</p>
        </div>
      </dt-section-card>
    `);
  }
}

customElements.define('dt-fees-section', FeesSection);
